import {
  toGetMyWalletHistory,
  toGetProfil,
} from "../../apis/actions/auth.actions";
import { toConfirmWalletTopUp } from "../../apis/actions/paymentMethods.actions";
import { AppDispatch } from "../../apis/store";
import { clearPendingWalletTopUp } from "../../utils/walletTopUp";

/** Credits a settled HyperPay payment to the wallet and refreshes the balance. */
export async function saveWalletTopUp({
  dispatch,
  lang,
  topupId,
  transactionId,
}: {
  dispatch: AppDispatch;
  lang: string;
  topupId: number;
  transactionId: string;
}): Promise<boolean> {
  const result = (await dispatch(
    toConfirmWalletTopUp({ topup_id: topupId, transaction_id: transactionId })
  )) as { payload?: { data?: any } };

  clearPendingWalletTopUp();

  // Odoo may answer bare or JSON-RPC wrapped; "already processed" also comes back 200.
  const data = result?.payload?.data;
  if ((data?.result ?? data)?.code !== 200) return false;

  await dispatch(toGetProfil(lang));
  dispatch(toGetMyWalletHistory());
  return true;
}
